import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    RadialLinearScale,
    PointElement,
    LineElement,
    ArcElement,
    BarElement,
    CategoryScale,
    LinearScale,
    Filler,
    Colors,
} from "chart.js";
import { Bar, Bubble, Doughnut } from "react-chartjs-2";
import { PolarAngleAxis, PolarGrid, Tooltip as TT, Radar, RadarChart, PolarRadiusAxis, ResponsiveContainer } from "recharts";

import ChartDataLabels from 'chartjs-plugin-datalabels'
ChartJS.register(
    Title,
    Tooltip,
    Legend,
    RadialLinearScale,
    PointElement,
    LineElement,
    ArcElement,
    BarElement,
    CategoryScale,
    LinearScale,
    Filler,
    ChartDataLabels,
    Colors
);
const CustomChart = props => {

    const { options, data, type, style, width: propWidth, height: propHeight, responsive } = props;

    // 레이더 차트 크기 계산 (props 또는 style에서 가져오기)
    const radarWidth = propWidth || (style?.width && typeof style.width === 'number' ? style.width : 300);
    const radarHeight = propHeight || (style?.height && typeof style.height === 'number' ? style.height : 220);

    return (
        <>
            {type === 'radar'
                ?
                <div
                    className="chart-wrp" style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                    {
                        data.length !== 0 && (
                            responsive ? (
                                // 반응형 모드: ResponsiveContainer 사용
                                <ResponsiveContainer width="100%" height={radarHeight} aspect={1}>
                                    <RadarChart
                                        data={data}
                                        cx="50%"
                                        cy="50%"
                                        outerRadius="70%"
                                    >
                                        <PolarGrid gridType="polygon" />
                                        <PolarAngleAxis dataKey="subject" />
                                        <PolarRadiusAxis domain={[0, 10]} tick={false} axisLine={false} />
                                        <Radar
                                            name=""
                                            dataKey="score"
                                            stroke="#6D2EF2"
                                            strokeWidth={1}
                                            fill="#F0EAFE"
                                            connectNulls={true}
                                        />
                                        <TT
                                            formatter={(value, name) => value}
                                            labelFormatter={(label) => `${label}`}
                                        />
                                    </RadarChart>
                                </ResponsiveContainer>
                            ) : (
                                // 고정 크기 모드
                                <RadarChart
                                    style={{
                                        margin: '0 auto'
                                    }}
                                    cx={radarWidth / 2}
                                    cy={radarHeight / 2}
                                    outerRadius={Math.min(radarWidth, radarHeight) / 2.8}
                                    width={radarWidth}
                                    height={radarHeight}
                                    data={data}
                                >
                                    <PolarGrid gridType="polygon" />
                                    <PolarAngleAxis dataKey="subject" />
                                    <PolarRadiusAxis domain={[0, 10]} tick={false} axisLine={false} />
                                    <Radar
                                        name=""
                                        dataKey="score"
                                        stroke="#6D2EF2"
                                        strokeWidth={1}
                                        fill="#F0EAFE"
                                        connectNulls={true}
                                    />
                                    <TT
                                        formatter={(value, name) => value}
                                        labelFormatter={(label) => `${label}`}
                                    />
                                </RadarChart>
                            )
                        )
                    }
                </div>
                : type === 'donut'
                    ?
                    <div className="chart-wrp">
                        {
                            data.length !== 0 &&
                            <Doughnut options={options} data={data} style={style} />
                        }
                    </div>
                    : type === 'horizontalBar'
                        ?
                        <div className="chart-wrp">
                            {
                                data.length !== 0 &&
                                <Bar options={options} data={data} style={style} />
                            }
                        </div>
                        :
                        type === 'bubble'
                            ?
                            <div className="chart-wrp">
                                {
                                    data.length !== 0 &&
                                    <Bubble options={options} data={data} style={style} />
                                }
                            </div>
                            :
                            null
            }
        </>
    )
}
export default CustomChart;
